import React from "react";
import { graphql } from "gatsby";
import { Form as FormComponent } from "@zempler/theme/src/components/form/Form";

export const Form = ({ data, ...rest }) => {
  return <FormComponent {...data} />;
};

export const FormQuery = graphql`
  fragment Form on UMBRACO_FormComponentType {
    formType
    disclaimerText
    heading
    subHeading
    successMessage
    successHeading
    submitButtonText
  }
`;
